import { request } from 'graphql-request';
import { API_URL } from 'appenv';

const addContactMutation = `
  mutation addContact($userRongcloudId: String!, $contactRongcloudId: String!) {
    addContact(input: {
      userUuid: $userRongcloudId,
      contactUuid: $contactRongcloudId
    }) {
      success
      contact {
        name
        firstName
        lastName
        uuid
        email
        customAttendeeFields
      }
    }
  }
`;

function addContact(userRongcloudId, contactRongcloudId) {
  return request(API_URL, addContactMutation, {
    userRongcloudId,
    contactRongcloudId,
  }).then(({ addContact: response }) => response)
    .catch((err) => {
      console.log(err);
    });
}

export default addContact;
